module.exports = __webpack_public_path__ + "img/powerAmplifier240w.188e6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/powerAmplifier240w.png
// module id = pguN
// module chunks = 0